(function() {
  // Only run on homepage or test page
  const pathname = window.location.pathname;
  if (pathname !== '/' && pathname !== '/index' && !pathname.endsWith('/test-redirect.html') && pathname !== '/test-redirect.html') {
    return;
  }

  // Get utm_term from URL params
  const urlParams = new URLSearchParams(window.location.search);
  const utmTerm = urlParams.get('utm_term');

  if (!utmTerm) {
    return;
  }

  // Localization mappings (inline data)
  const mappings = [{"utm_term":"9DLV4XP","language":"fr","currency":"EUR"},{"utm_term":"R3GBZ2T","language":"es","currency":null}];

  // Find matching language for utm_term
  const mapping = Array.isArray(mappings) 
    ? mappings.find(item => item.utm_term === utmTerm)
    : null;
  
  if (mapping && mapping.language) {
    // Get current URL without utm_term param
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete('utm_term');
    
    // Build path segment with language and currency (if specified)
    // Format: /{language}-{currency} or /{language}
    let pathSegment = mapping.language;
    if (mapping.currency) {
      pathSegment = `${mapping.language}-${mapping.currency.toLowerCase()}`;
    }
    
    // Build redirect URL with language-currency path
    const redirectUrl = currentUrl.pathname === '/' 
      ? `/${pathSegment}`
      : `/${pathSegment}${currentUrl.pathname}`;
    
    // Create new URL object for redirect
    const redirect = new URL(redirectUrl, window.location.origin);
    
    // Copy existing query parameters (except utm_term which we already removed)
    currentUrl.searchParams.forEach((value, key) => {
      redirect.searchParams.set(key, value);
    });
    
    window.location.href = redirect.toString();
  }
})();

